export default function initializeVariations() {
    initializeCartButton();
    // updateVariationShippingTooltip();
}

function initializeCartButton() {
    // changeCartButtonState();
}

function changeCartButtonState() {
    setTimeout(function() {
        let button = document.querySelector('.single_add_to_cart_button');

        if(button) {
            if (button.classList.contains('disabled')) {
                button.setAttribute('disabled', 'true');
            } else {
                button.removeAttribute('disabled');
            }
        }
    }, 200);
}

window.getVariationShippingData = getVariationShippingData;

async function getVariationShippingData(id = '0') {
    const params = {
        'wc-ajax': 'variation_shipping_array',
        'id': id
    };

    const url = window.location.origin + '/?' + new URLSearchParams(params);

    const request = new Request(url, {
        method: 'GET',
    });

    const response = await fetch(request);

    return response.json();
}